<div class="modal-container" [ngClass]="[isRemoveVersion ? 'remove-version' : '', isHtml ? 'change-height' : '']">
    <div class="header-container">
        <mat-icon [svgIcon]="icon" class="modal-icon"></mat-icon>
    </div>

    <div class="body-container">
        <h4 class="modal-title">{{ title }}</h4>
        <span *ngIf="messageDestacada" class="modal-message-destacada">{{ messageDestacada }}</span>
        @if (!isHtml) {
            <span class="modal-message">{{ message }}</span>
        } @else {
            <span class="modal-message" [innerHTML]="message"></span>
        }
    </div>

    <div class="footer-container">
        <button mat-button name="modal-btn-decline" (click)="decline()" class="btn-decline" *ngIf="btnCancelText">
            <span class="paragraph-regular">{{ btnCancelText }}</span>
        </button>
        <button mat-button name="modal-btn-confirm" (click)="accept()" class="btn-confirm" [ngClass]="[!btnCancelText ? 'unico' : '']">
            <span class="paragraph-regular">{{ btnOkText }}</span>
        </button>
    </div>
</div>